module.exports = __webpack_public_path__ + "img/eyeimage.a4d637e5.svg";